import type { Messages } from '../i18n/messages';

/**
 * Quicklinks chrome. The user's saved links (title/url) are their own data and
 * stay raw — only the surrounding labels are keyed (see CLAUDE.md server-data rule).
 */
export const quicklinksMessages: Messages = {
  'quicklinks.nav.label': { en: 'Quicklinks', fun: 'Fast Lanes' },
  'quicklinks.manager.title': { en: 'Quicklinks', fun: 'Fast Lanes' },
  'quicklinks.manager.shortcutLabel': {
    en: 'Keyboard shortcuts',
    fun: 'Keyboard shortcuts',
  },
  'quicklinks.manager.shortcutOpen': {
    en: 'Cmd/Ctrl + Shift + K — Open quicklinks',
    fun: 'Cmd/Ctrl + Shift + K — Open quicklinks',
  },
  'quicklinks.manager.shortcutMove': {
    en: '↑ ↓ — Move between links',
    fun: '↑ ↓ — Move between links',
  },
  'quicklinks.manager.shortcutEnter': {
    en: 'Enter — Open the highlighted link',
    fun: 'Enter — Open the highlighted link',
  },
  'quicklinks.manager.shortcutNewTab': {
    en: 'Shift + Enter — Open in a new tab',
    fun: 'Shift + Enter — Open in a new tab',
  },
  'quicklinks.manager.addCurrent': {
    en: 'Add current page',
    fun: 'Stash this page',
  },
  'quicklinks.manager.close': { en: 'Close', fun: 'Close' },
  'quicklinks.manager.empty.title': {
    en: 'No quicklinks yet',
    fun: 'No fast lanes yet',
  },
  'quicklinks.manager.empty.description': {
    en: 'Add the page you are on for one-click access later.',
    fun: 'Stash the page you are on for one-tap access later.',
  },
  'quicklinks.row.open': { en: 'Open', fun: 'Open' },
  'quicklinks.row.openNewTab': {
    en: 'Open in new tab',
    fun: 'Open in new tab',
  },
  'quicklinks.row.edit': { en: 'Edit', fun: 'Edit' },
  'quicklinks.row.titleLabel': { en: 'Title', fun: 'Title' },
  'quicklinks.row.urlLabel': { en: 'URL', fun: 'URL' },
  'quicklinks.row.save': { en: 'Save', fun: 'Save' },
  'quicklinks.row.cancel': { en: 'Cancel', fun: 'Cancel' },
  'quicklinks.row.changeIcon': { en: 'Change icon', fun: 'Swap icon' },
  'quicklinks.row.moveUp': { en: 'Move up', fun: 'Bump up' },
  'quicklinks.row.moveDown': { en: 'Move down', fun: 'Bump down' },
  'quicklinks.row.delete': { en: 'Delete', fun: 'Toss' },
  'quicklinks.delete.title': {
    en: 'Delete quicklink?',
    fun: 'Toss this fast lane?',
  },
  'quicklinks.delete.description': {
    en: 'This removes {title} from your quicklinks.',
    fun: 'This yeets {title} from your fast lanes.',
  },
  'quicklinks.delete.confirm': { en: 'Delete', fun: 'Toss it' },
  'quicklinks.iconPicker.colorLabel': { en: 'Color', fun: 'Color' },
  'quicklinks.iconPicker.searchPlaceholder': {
    en: 'Search icons',
    fun: 'Search icons',
  },
  'quicklinks.iconPicker.count': {
    en: '{total} icons',
    fun: '{total} icons',
  },
  'quicklinks.iconPicker.noResults': {
    en: 'No icons match',
    fun: 'No icons match',
  },
};
